angular.module("AccountingBoxApp").config(function($stateProvider) {
  $stateProvider
    .state("app.company.contacts", {
      url: "/sale/customers",
      // templateUrl: "app/contacts/masterDetail/masterDetail.html",
      // controller: "ContactsMasterDetailCtrl",
      // controllerAs: "cmd",
      // resolve: {
      //   customers: function(Customer) {
      //     return Customer.find({ filter: { order: "name ASC" } }).$promise;
      //   }
      // }
      template: "<ui-view/>",
    })
    .state("app.company.contacts.new", {
      url: "/nieuw",
      template: "<ui-view/>",

      // component: "contactEdit",
      // resolve: {
      //   customer: function(Customer) {
      //     var customer = new Customer();
      //     customer.isNew = true;
      //     customer.type = "business";
      //     customer.bankAccountNumbers = [""];
      //     return customer;
      //   }
      // }
    })
    .state("app.company.contacts.edit", {
      url: "/:id/bewerk",
      template: "<ui-view/>",
      // component: "contactEdit",
      // resolve: {
      //   customer: function($transition$, Customer) {
      //     return Customer.findById({
      //       id: $transition$.params().id
      //     }).$promise;
      //   }
      // }
    });
});
